import('./swiper').then(() => undefined)
